import { c as _c } from "react/compiler-runtime";
import { CONFIG } from 'src/global-config';
import { Image } from 'src/components/image';

// ----------------------------------------------------------------------

export function UploadIllustration(t0) {
  const $ = _c(11);
  let other;
  let sx;
  if ($[0] !== t0) {
    const {
      ref,
      hideBackground,
      sx: t1,
      ...t2
    } = t0;
    sx = t1;
    other = t2;
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
  } else {
    other = $[1];
    sx = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: 320,
      height: "auto"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== sx) {
    t2 = Array.isArray(sx) ? sx : [sx];
    $[4] = sx;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = [t1, ...t2];
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== other || $[9] !== t3) {
    t4 = <Image alt="Upload Illustration" src={`${CONFIG.assetsDir}/assets/illustrations/illustration-upload.webp`} sx={t3} {...other} />;
    $[8] = other;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}